/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserSubscriptionProductQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserSubscriptionProductQuery = { __typename?: 'Query', userSubscriptionProduct?: { __typename?: 'StripeProduct', id: string, name?: string | null, metadata?: { __typename?: 'Metadata', background_colour?: string | null } | null } | null };


export const UserSubscriptionProductDocument = gql`
    query userSubscriptionProduct {
  userSubscriptionProduct {
    id
    name
    metadata {
      background_colour
    }
  }
}
    `;

/**
 * __useUserSubscriptionProductQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionProductQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSubscriptionProductQuery(baseOptions?: Apollo.QueryHookOptions<UserSubscriptionProductQuery, UserSubscriptionProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSubscriptionProductQuery, UserSubscriptionProductQueryVariables>(UserSubscriptionProductDocument, options);
      }
export function useUserSubscriptionProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSubscriptionProductQuery, UserSubscriptionProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSubscriptionProductQuery, UserSubscriptionProductQueryVariables>(UserSubscriptionProductDocument, options);
        }
export function useUserSubscriptionProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserSubscriptionProductQuery, UserSubscriptionProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSubscriptionProductQuery, UserSubscriptionProductQueryVariables>(UserSubscriptionProductDocument, options);
        }
export type UserSubscriptionProductQueryHookResult = ReturnType<typeof useUserSubscriptionProductQuery>;
export type UserSubscriptionProductLazyQueryHookResult = ReturnType<typeof useUserSubscriptionProductLazyQuery>;
export type UserSubscriptionProductSuspenseQueryHookResult = ReturnType<typeof useUserSubscriptionProductSuspenseQuery>;
export type UserSubscriptionProductQueryResult = Apollo.QueryResult<UserSubscriptionProductQuery, UserSubscriptionProductQueryVariables>;